import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const FEATURE_NAME = "student-parents";
export const PATH_TO_STUDENT_PARENTS_STATE = FEATURE_NAME;
export const baseActionsPath = `seneca/${FEATURE_NAME}`;

export const studentParentsCrudStateConfig: CrudConfig = {
  name: FEATURE_NAME,
  path: `${baseActionsPath}/meta`,
  callTypes: [AllowedCallTypes.FETCH, AllowedCallTypes.UPDATE]
};
